module.exports = __webpack_public_path__ + "static/media/dashboard_dark.a983df75.svg";